import { Bell, BellOff } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const NotificationsIcon = createLucideIcon(Bell);
export const NotificationsOffIcon = createLucideIcon(BellOff);
